import { ATTACHMENT_MODULE_PREFIX } from '../constants';
export const ATTACHMENT_ADD_ATTACHMENTS = `${ATTACHMENT_MODULE_PREFIX}_ADD_ATTACHMENTS`;
export const ATTACHMENT_UPDATE_ATTACHMENTS = `${ATTACHMENT_MODULE_PREFIX}_UPDATE_ATTACHMENTS`;
export const ATTACHMENT_DELETE_ATTACHMENTS = `${ATTACHMENT_MODULE_PREFIX}_DELETE_ATTACHMENTS`;
export const ATTACHMENT_DELETE_ATTACHMENTS_SUCCESS = `${ATTACHMENT_MODULE_PREFIX}_DELETE_ATTACHMENTS_SUCCESS`;
export const ATTACHMENT_DELETE_ATTACHMENTS_FAILURE = `${ATTACHMENT_MODULE_PREFIX}_DELETE_ATTACHMENTS_FAILURE`;
export const ATTACHMENT_RESET_ATTACHMENTS = `${ATTACHMENT_MODULE_PREFIX}_RESET_ATTACHMENTS`;
export const ATTACHMENT_SELECT_ATTACHMENT = `${ATTACHMENT_MODULE_PREFIX}_SELECT_ATTACHMENT`;
export const ATTACHMENT_CLEAR_ALL_ATTACHMENT_SELECTIONS = `${ATTACHMENT_MODULE_PREFIX}_CLEAR_ALL_ATTACHMENT_SELECTIONS`;
export const addAttachmentsAction = (payload) => ({
    type: ATTACHMENT_ADD_ATTACHMENTS,
    payload
});
export const updateAttachmentsAction = (payload) => ({
    type: ATTACHMENT_UPDATE_ATTACHMENTS,
    payload
});
export const deleteAttachmentsAction = (attachments) => ({
    type: ATTACHMENT_DELETE_ATTACHMENTS,
    payload: { attachments }
});
export const deleteAttachmentsSuccessAction = (attachmentIds) => ({
    type: ATTACHMENT_DELETE_ATTACHMENTS_SUCCESS,
    payload: { attachmentIds }
});
export const deleteAttachmentsFailureAction = (errorMessage) => ({
    type: ATTACHMENT_DELETE_ATTACHMENTS_FAILURE,
    payload: { errorMessage }
});
export const resetAttachmentsDataAction = () => ({
    type: ATTACHMENT_RESET_ATTACHMENTS,
    payload: null
});
export const selectAttachmentAction = (id) => ({
    type: ATTACHMENT_SELECT_ATTACHMENT,
    payload: { id }
});
export const clearAllSelectedAttachments = () => ({
    type: ATTACHMENT_CLEAR_ALL_ATTACHMENT_SELECTIONS,
    payload: null
});
//# sourceMappingURL=actions.js.map